import {useEffect, useState} from 'react';
import {getReportSavedSegments} from '../../firebase/firestore/savedSegments';

export default function useSavedSegments(reportId, currentDocKey) {
    const [savedSegments, setSavedSegments] = useState([]);

    useEffect(() => {
        let isCancelled = false;

        async function load() {
            try {
                if (!reportId || !currentDocKey) {
                    setSavedSegments([]);
                    return;
                }
                const all = await getReportSavedSegments(reportId);
                if (isCancelled) return;
                const filtered = (all || []).filter(seg => seg?.docId === currentDocKey);
                setSavedSegments(filtered);
            } catch (e) {
                console.error('Failed to load saved segments:', e);
                setSavedSegments([]);
            }
        }

        load();
        return () => {
            isCancelled = true;
        };
    }, [reportId, currentDocKey]);

    return {savedSegments, setSavedSegments};
}

